/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, Platform, Animated, TouchableWithoutFeedback } from 'react-native';
import Images from '../images';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { JDTouchable, JDDevice, JDText, JDImage } from '@jdreact/jdreact-core-lib';

import Store from '../services/goodsContrastPageStore/store';
//埋点
import { logClick, ContrastHide, ContrastProductTab } from '../mta/MtaService';
import throttle from '../utils/throttle';
const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  tabControl: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: getRpx(750),
    height: getRpx(90),
    backgroundColor: '#ffffff',
    paddingLeft: getRpx(36),
    elevation: 4,
    shadowOffset: {
      width: 0,
      height: getRpx(4),
    },
    shadowColor: '#000000',
    shadowOpacity: 0.08,
    shadowRadius: getRpx(12),
  },
  tab: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: Platform.OS == 'web' ? 'auto' : Platform.OS == 'ios' ? getRpx(104) : getRpx(124),
    height: getRpx(90),
    overflow: 'visible',
  },
  marginLR18: {
    marginLeft: getRpx(18),
    marginRight: getRpx(18),
  },
  text: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: Platform.OS == 'web' ? 'auto' : Platform.OS == 'ios' ? getRpx(104) : getRpx(124),
    height: getRpx(37),
    marginTop: getRpx(6),
    marginBottom: getRpx(6),
    lineHeight: Platform.OS !== 'web' ? getRpx(37) : 'normal',
    fontSize: getRpx(26),
    color: '#262626',
    overflow: 'visible',
  },
  current: {
    fontWeight: 'bold',
  },
  curIcon: {
    width: getRpx(52),
    height: getRpx(6),
    position: 'absolute',
    top: getRpx(69),
    left: 0,
  },
  wrap: {
    width: getRpx(230),
    height: getRpx(90),
    marginLeft: getRpx(6),
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkBox: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: getRpx(17),
    width: getRpx(230),
    height: getRpx(90),
  },
  radioBg: {
    width: getRpx(56),
    height: getRpx(56),
  },
  radioChecked: {
    width: getRpx(56),
    height: getRpx(56),
  },
  textCheck: {
    marginLeft: getRpx(4),
    // width: getRpx(156),
    height: getRpx(37),
    lineHeight: getRpx(37),
    fontSize: getRpx(26),
    color: '#8C8C8C',
  },
  btnShadow: {
    width: getRpx(28),
    height: getRpx(90),
  },
});
interface IStoreProps {
  store: {
    entrySku: string;
    tabCtrlList: { text: string; checked: boolean }[];
    tabCtrlIndex: number;
    tabLeftArr: number[];
    SamePropsCheck: boolean;
    handleSwitchTab: (index: number) => void;
    handleHideSameProps: () => void;
    initTabLeft: (left: number, width: number) => void;
  };
}
interface IProps extends IStoreProps {}
interface IState {
  tabLeft: number;
  width: number;
  leftArr: [];
}
class TabControl extends React.Component<IProps, IState> {
  private left: any[] = [];
  constructor(props: IProps) {
    super(props);
    this.state = {
      tabLeft: new Animated.Value(Platform.OS === 'android' ? getRpx(90) : getRpx(80)),
      width: getRpx(140),
      leftArr: [],
    };
    this.handleSwitchTab = this.handleSwitchTab.bind(this);
  }
  componentDidMount() {
    const { store } = this.props;
    const { tabLeftArr, tabCtrlIndex } = store;
    if (tabLeftArr.length > 0 && tabCtrlIndex > 0) {
      this.setState({ tabLeft: new Animated.Value(tabLeftArr[tabCtrlIndex]) });
    }
  }
  handleSwitchTab(index: number) {
    const { store } = this.props;
    const { tabLeftArr } = store;
    store.handleSwitchTab(index);
    Animated.timing(this.state.tabLeft, {
      toValue: tabLeftArr[index],
      duration: 280,
      useNativeDriver: true,
    }).start();
    logClick({
      event_id: ContrastProductTab,
      // 1-外观价格/2-基本参数/3-商品口碑
      event_param: `${index + 1}`,
      page_param: store.entrySku,
    });
  }
  handleHideSameProps = throttle(() => {
    const { store } = this.props;
    const { SamePropsCheck, entrySku } = store;
    logClick({
      event_id: ContrastHide,
      // 1-隐藏/2-取消
      event_param: SamePropsCheck ? '2' : '1',
      page_param: entrySku,
    });
    store.handleHideSameProps();
  }, 200);
  layout = ({
    nativeEvent: {
      layout: { x, y, width, height },
    },
  }: any) => {
    //设置lef值
    this.props.store.initTabLeft(x, width);
  };
  render() {
    const { store } = this.props;
    const { tabCtrlList, SamePropsCheck } = store;
    return (
      <View
        style={[
          styles.tabControl,
          {
            boxShadow: '0px 8px 20px 0px rgba(0,0,0,0.05)',
          },
        ]}
      >
        {tabCtrlList.map((tab, index: number) => (
          <TouchableWithoutFeedback key={`tab-${index}`} onPress={this.handleSwitchTab.bind(this, index)}>
            <View style={[styles.tab, styles.marginLR18]} onLayout={this.layout}>
              <JDText style={tab.checked ? [styles.text, styles.current] : styles.text}>{tab.text}</JDText>
            </View>
          </TouchableWithoutFeedback>
        ))}
        <Animated.Image
          source={Images.contrast.curIcon}
          style={[
            styles.curIcon,
            {
              transform: [
                {
                  translateX: this.state.tabLeft,
                },
              ],
            },
          ]}
        ></Animated.Image>
        <View style={styles.wrap}>
          <JDImage source={Images.contrast.BtnShadow} style={styles.btnShadow}></JDImage>
          <JDTouchable onPress={this.handleHideSameProps}>
            <View style={styles.checkBox}>
              <JDImage
                source={SamePropsCheck ? Images.common.radioCheck : Images.common.radioBg}
                style={[styles.radioBg, styles.marginT]}
              ></JDImage>
              <JDText style={styles.textCheck}>隐藏相同</JDText>
            </View>
          </JDTouchable>
        </View>
      </View>
    );
  }
}

const TabControlPageOberver = observer(TabControl);
const TabControlOberverWapper = (props: IProps) => <TabControlPageOberver {...props} store={Store} />;
export default TabControlOberverWapper;
